export const USERS = ["A", "B"];

export function normalizeUsername(value) {
  if (!value) return null;
  const name = String(value).trim().toUpperCase();
  return USERS.includes(name) ? name : null;
}

export function getOtherUser(username) {
  const normalized = normalizeUsername(username);
  if (normalized === "A") return "B";
  if (normalized === "B") return "A";
  return null;
}

export function normalizeMessages(value) {
  const parsed =
    typeof value === "string"
      ? JSON.parse(value)
      : value && typeof value === "object"
        ? value
        : {};

  return {
    A: String(parsed.A ?? ""),
    B: String(parsed.B ?? ""),
  };
}

export function normalizeSeen(value) {
  const parsed =
    typeof value === "string"
      ? JSON.parse(value)
      : value && typeof value === "object"
        ? value
        : {};

  return {
    A: parsed.A === "A" || parsed.A === "B" ? parsed.A : null,
    B: parsed.B === "A" || parsed.B === "B" ? parsed.B : null,
  };
}

export function normalizeLastLogins(value) {
  const parsed =
    typeof value === "string"
      ? JSON.parse(value)
      : value && typeof value === "object"
        ? value
        : {};

  return {
    A: parsed.A ?? null,
    B: parsed.B ?? null,
  };
}

export function normalizeSeenAt(value) {
  const parsed =
    typeof value === "string"
      ? JSON.parse(value)
      : value && typeof value === "object"
        ? value
        : {};

  return {
    A: parsed.A ?? null,
    B: parsed.B ?? null,
  };
}

export function formatSeenAt(value) {
  if (!value) return null;
  return new Date(value).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour12: true,
  });
}

export function emptyChatState() {
  return {
    messages: { A: "", B: "" },
    seen: { A: null, B: null },
    seenAt: { A: null, B: null },
    lastLogins: { A: null, B: null },
  };
}
